import React, { FC } from "react";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";
import { RadiologistCalendarConflict } from "@Shape-Digital/kudzu-data/lib/types/actions";
import { formatMinutes } from "./timeFormatUtils";
import useConflictAlertTranslations from "./useConflictAlertTranslations";

export type CalendarConflict = RadiologistCalendarConflict;

type Props = {
  open: boolean;
  conflicts: CalendarConflict[];
  onEdit: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

const ConflictAlert: FC<Props> = ({
  open,
  conflicts,
  onEdit,
  onConfirm,
  isLoading = false,
}) => {
  const t = useConflictAlertTranslations();

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>{t.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 4 }}>
          {t.description}
        </Typography>
        <Alert severity="warning">
          <Typography variant="body2">{t.warningText}</Typography>
          <Box component="ul" sx={{ m: 0, pl: 3, pt: 3 }}>
            {conflicts.map((conflict) => {
              const dateLabel = format(parseISO(conflict.date), "EEE, MMM d");
              const timeLabel = formatMinutes(
                conflict.latestStatAppointmentMinutes,
              );
              return (
                <Box
                  component="li"
                  key={`${conflict.centerUserId}-${conflict.date}`}
                >
                  <Typography variant="body2">
                    {t.conflictItem(
                      conflict.firstName,
                      conflict.lastName,
                      dateLabel,
                      timeLabel,
                    )}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onEdit} disabled={isLoading}>
          {t.btnEdit}
        </Button>
        <Button
          size="small"
          onClick={onConfirm}
          color="error"
          disabled={isLoading}
        >
          {t.btnSave}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConflictAlert;
